<template>
  <div class="flex flex-col flex-1">
    <div>
      <div class="page-alerts space-y-6">
        <template v-if="$route.meta.cmsLicensesRenewAlert">
          <license-renew-alert
            type="CMS"
            :expiring-licenses-total="expiringCmsLicensesTotal"
          />
        </template>

        <template v-if="$route.meta.pluginLicensesRenewAlert">
          <license-renew-alert
            type="plugin"
            :expiring-licenses-total="expiringPluginLicensesTotal"
          />
        </template>
        <PaymentMethodAlert />
      </div>
    </div>

    <div
      class="page-content px-6 pt-6 pb-20 mx-auto max-w-screen-xl w-full"
      :class="{
        'flex-1 flex flex-col': $route.meta.flexContent,
      }"
    >
      <slot name="page-heading">
        <PageHeader v-if="heading">{{ heading }}</PageHeader>
      </slot>
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
  import LicenseRenewAlert from '@console/components/licenses/LicenseRenewAlert.vue';
  import PaymentMethodAlert from '@console/components/cloud/PaymentMethodAlert.vue';
  import {computed} from 'vue';
  import {useStore} from 'vuex';
  import PageHeader from '@console/components/app/PageHeader.vue';

  const {state} = useStore();
  defineProps<{
    heading?: string;
  }>();

  const expiringCmsLicensesTotal = computed(() => {
    return state.cmsLicenses.expiringCmsLicensesTotal;
  });

  const expiringPluginLicensesTotal = computed(() => {
    return state.pluginLicenses.expiringPluginLicensesTotal;
  });
</script>
